module.exports = __webpack_public_path__ + "c0617c01305ac6e45235953d396449f8.svg";